import React from "react";
import {useSelector} from "react-redux";
import {USER_SUPERADMIN} from "../shared/constants";
import {Typography, Grid} from "@mui/material";
import CustomerReportingDefaultEmailList from "../components/customer-reporting-default-email-list";
import CustomerReporting from "../components/customer-reporting";


const Settings =  () => {
    const currentUser = useSelector((state) => state.dataStore.get("currentUser"));
    const authorization = useSelector((state) =>
        state.dataStore.getIn(["currentUser", "authorization"])
    );

    if (authorization !== USER_SUPERADMIN) {
        return <Typography component={"label"} variant={"label"}>You are not authorized to view this page.</Typography>
    }

    return <Grid className={"settings-tab"} container>
        <Grid xs={12} item>
            <Typography component={"span"} variant={"span"}>
                USAGE REPORT
            </Typography>
        </Grid>
        <Grid item xs={12}>
            <CustomerReporting />
        </Grid>
        <Grid item xs={12}>
            <CustomerReportingDefaultEmailList />
        </Grid>
    </Grid>
};

export default Settings;
